.ad{aspect-ratio:1/1;}